import React, { useState, useEffect } from 'react';
import { Bell, BellOff, Loader2 } from 'lucide-react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { toast } from 'sonner';

export const NotificationToggle = ({ userType = 'visitor', userId = null, email = null }) => {
  const {
    isSupported,
    isSubscribed,
    permission,
    isLoading,
    error,
    subscribe,
    unsubscribe
  } = usePushNotifications(userType, userId, email);

  const handleToggle = async () => {
    if (isSubscribed) {
      const success = await unsubscribe();
      if (success) {
        toast.success('Notifications disabled');
      } else {
        toast.error('Failed to disable notifications');
      }
    } else {
      const success = await subscribe();
      if (success) {
        toast.success('Notifications enabled! You\'ll receive updates here.');
      } else if (permission === 'denied') {
        toast.error('Please enable notifications in your browser settings');
      } else {
        toast.error('Failed to enable notifications');
      }
    }
  };

  if (!isSupported) {
    return null; // Don't show if not supported
  }

  return (
    <button
      onClick={handleToggle}
      disabled={isLoading}
      className={`p-2 rounded-lg transition-all ${
        isSubscribed 
          ? 'bg-neon-cyan/20 text-neon-cyan hover:bg-neon-cyan/30' 
          : 'bg-white/5 text-slate-400 hover:bg-white/10 hover:text-white'
      }`}
      title={isSubscribed ? 'Notifications enabled' : 'Enable notifications'}
      data-testid="notification-toggle"
    >
      {isLoading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : isSubscribed ? (
        <Bell className="w-5 h-5" />
      ) : (
        <BellOff className="w-5 h-5" />
      )}
    </button>
  );
};

export default NotificationToggle;
